import React from "react";
import RetailPricingScreen from "../RetailPricingScreen";

export default function RetailPage({ match }) {
  return <RetailPricingScreen match={match} record_type={"technorama_retail"} />;
}
